export default __webpack_public_path__ + "static/media/leftarrow.13c424d2.svg";